import * as R from 'ramda';

export type TruncationMethod = 'first' | 'startEnd';

const truncateFirst = (value: string, charactersToDisplay: number): string => {
  const lengthToDisplay = charactersToDisplay > value.length ? value.length : charactersToDisplay;
  return value.substring(0, lengthToDisplay);
};

const truncateStartEnd = (value: string, charactersToDisplay: number): string => {
  if (value.length <= charactersToDisplay * 2) {
    return truncateFirst(value, charactersToDisplay);
  }

  return R.join('...', [
    value.substring(0, charactersToDisplay),
    value.substring(value.length - charactersToDisplay, value.length),
  ]);
};
/**
 * extract the did from a did matches string of the form did:sol:<walletAddress> OR did:sol:<walletAddress>|<status>
 * @param matchString: did:sol:<walletAddress> OR did:sol:<walletAddress>|<status>
 * @returns {string}
 */
const stripDidPreamble = (matchStr: string): string => {
  const val = R.last(matchStr.split(':')) || '';
  // remove the gatekeeper status if present
  return val.split('|')[0];
};

const truncateDid = (did: string, charactersToDisplay = 6, method: TruncationMethod = 'first'): string => {
  const valueToDisplay = stripDidPreamble(did);

  switch (method) {
    case 'startEnd':
      return truncateStartEnd(valueToDisplay, charactersToDisplay);
    case 'first':
    default:
      return truncateFirst(valueToDisplay, charactersToDisplay);
  }
};

export default {
  truncateDid,
  stripDidPreamble,
};
